
import { Route, Routes } from 'react-router-dom';

import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import './App.css';

import { AnimatePresence } from "framer-motion";

import ScrollToTop from "react-scroll-to-top";

import Contact from './Pages/Contact/Contact';
import ProjectGraphicsDev from './Pages/Project/Project Graphics dev/ProjectGraphicsDev';
import ProjectUiDev from './Pages/Project/Project UI Dev/ProjectUiDev';
import ProjectWebDevSingle from './Pages/Project/Project Web dev/ProjectWebDevSingle';
import ProjectWebDev from './Pages/Project/Project Web dev/ProjectWebDev';
import ProjectMain from './Pages/Project/ProjectMain';
import Skill from './Pages/Skill/Skill';
import About from './Pages/About/About';
import Home from './Pages/Home/Home';
import ThankYou from './Pages/Thank you/ThankYou';

function App() {

  
  
  
  return (

    <AnimatePresence >

    <Routes>

      <Route path='/thankyou' element={<ThankYou />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/project/projectgraphicsdev' element={<ProjectGraphicsDev />} />
      <Route path='/project/projectuidev' element={<ProjectUiDev />} />
      <Route path='/project/projectwebdev/:slug' element={<ProjectWebDevSingle />} />
      <Route path='/project/projectwebdev' element={<ProjectWebDev />} />
      <Route path='/project' element={<ProjectMain />} />
      <Route path='/skill' element={<Skill />} />
      <Route path='/about' element={<About />} />
      <Route path='/' element={<Home />} />
      

    </Routes>

    <ScrollToTop smooth />

    </AnimatePresence>

  );
}

export default App;
